export * from './verifyLicense';